export const STORAGE_TOKEN_KEY = 'token';
export const STORAGE_PLATFORM_KEY = 'platform';
export const STORAGE_CHANNEL_KEY = 'channel';
